<template>
  <v-row>
    <v-col cols="12" class="px-0">
      <v-toolbar color="transparent" flat height="48">
        <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
          <router-link :to="{name: 'Components'}" class="subtitle-1 routerLink font-weight-medium">Componentes</router-link> <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon> Signup Forms
        </v-toolbar-title>
      </v-toolbar>
    </v-col>
    <v-col cols="4" v-if="$store.state.apps.retrieveLoader">
      <v-skeleton-loader type="article" />
    </v-col>

    <!-- feature landing page -->
    <template v-else-if="formsList && formsList.length === 0">
      <v-col cols="12">
        <v-sheet class="component-hero" rounded="lg">
          <v-row class="pt-6 pl-6" align="start" justify="center">
            <v-col cols="7">
              <v-avatar color="white" size="48">
                <img :src="require('@/assets/appIcon-apps--SignupForms.svg')" style="width:28px;height:28px;border-radius:0;" />
              </v-avatar>
              <span class="d-block mt-2 text-h5 text--secondary font-weight-medium">Permite a tus clientes suscribirse y pagar</span>
              <span class="d-block mt-2 body-1 text--secondary font-weight-regular">Agrega funcionalidad de suscripción y pago a tu sitio web o aplicación sin escribir código. Captura la información de facturación y la tarjeta de crédito de tus clientes.</span>
              <v-btn class="mt-14" :to="{name: 'FormCreate'}" color="primary">Comenzar</v-btn>
            </v-col>
            <v-col cols="5" class="pb-0">
              <v-carousel cycle hide-delimiters :show-arrows="false" height="300" interval="4000" vertical>
                <v-carousel-item v-for="(item, i) in demoImages" :key="i" :src="require(`@/assets/${item}.svg`)" />
              </v-carousel>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
      <v-col cols="7">
        <v-row align="space-between" no-gutters>
          <span class="d-block text--secondary subtitle-1 font-weight-medium">Comienza a recibir clientes</span>
          <v-spacer />
          <v-btn href="https://www.piriod.com/signup-forms" target="_blank" color="primary" text :ripple="false">Más información<v-icon right small>mdi-open-in-new</v-icon></v-btn>
        </v-row>
        <v-divider />
        <v-row>
          <v-col>
            <v-avatar class="mb-2" color="indigo" size="36"><v-icon dark>mdi-brush</v-icon></v-avatar>
            <span class="d-block text--secondary subtitle-1 font-weight-medium">Crea y personaliza</span>
            <span class="d-block mt-2 body-2">Crea formularios completamente adaptados a tus necesidades sin una sola línea de código. Personaliza campos, estilos y flujos en cuestión de minutos.</span>
          </v-col>
          <v-col>
            <v-avatar class="mb-2" color="indigo" size="36"><v-icon dark>mdi-lightning-bolt</v-icon></v-avatar>
            <span class="d-block text--secondary subtitle-1 font-weight-medium">Automatiza la incorporación</span>
            <span class="d-block mt-2 body-2">Permite que tus clientes se suscriban de manera auto-asistida, 24/7, sin que tú o tu equipo tengan que intervenir manualmente en el proceso.</span>
          </v-col>
          <v-col>
            <v-avatar class="mb-2" color="indigo" size="36"><v-icon dark>mdi-chart-timeline-variant-shimmer</v-icon></v-avatar>
            <span class="d-block text--secondary subtitle-1 font-weight-medium">Aumenta la conversión</span>
            <span class="d-block mt-2 body-2">Optimiza la experiencia del cliente con formularios que guían a los usuarios de manera intuitiva, aumentando la tasa de finalización y reduciendo el abandono.</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="5">
        <v-row align="space-between" no-gutters>
          <span class="d-block text--secondary subtitle-1 font-weight-medium">Precios</span>
          <v-spacer />
          <v-btn @click="intercomNewMessage('Hola, me interesa saber más sobre los formularios de suscripción')" color="primary" text :ripple="false">Contactar a ventas<v-icon right small>mdi-forum-outline</v-icon></v-btn>
        </v-row>
        <v-divider />
        <v-row align="space-between">
          <v-col cols="6" v-for="p in product" :key="`price-${p.id}`">
            <v-sheet class="px-4" height="190" rounded>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 text--secondary font-weight-medium">{{ p.name }}<v-chip v-if="p.isCommingSoon" class="mx-3 mt-n1" color="defaultGrey" text-color="secondary" x-small>Próximamente</v-chip></v-list-item-title>
                  <v-list-item-subtitle class="text--secondary font-weight-medium">
                    <template v-if="p.prices[account.country.id]">
                      {{ p.prices[account.country.id].price }} {{ p.prices[account.country.id].currency }}
                    </template>
                    <template v-else>
                      {{ p.prices.global.price }} {{ p.prices.global.currency }}
                    </template>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider />
              <span class="d-block py-3 body-2 text--primary font-weight-regular">{{ p.description }}</span>
            </v-sheet>
          </v-col>
        </v-row>
      </v-col>
    </template>
    <!-- end feature landing page -->

    <template v-else>
      <v-col cols="4" v-for="d in formsList" :key="d.id">
        <v-card class="card-apps" :to="{ name: 'FormDetail', params: { id: d.id } }">
          <v-card-text class="py-6 px-0">
            <v-list class="transparent">
              <v-list-item>
                <v-list-item-icon>
                  <img :src="require(`@/assets/appIcon-apps--SignupForms.svg`)" width="24px">
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 text--secondary font-weight-medium">{{d.name}}</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-chip class="my-1 mr-1" color="secondary" small v-for="ap in d.available_plans.slice(0, 2)" :key="ap.id">
                      <span>{{ap.plan.name}}</span>
                    </v-chip>
                    <span class="ml-1 py-2" v-if="d.available_plans.length > 2">(+{{d.available_plans.length - 2}} otros)</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="card-apps background" :to="{name: 'FormCreate'}" outlined>
          <v-card-text class="py-13 text-center subtitle-1 primary--text font-weight-medium">Crear un nuevo Signup Form</v-card-text>
        </v-card>
      </v-col>
    </template>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { signupForms } from '../../../collections/products'

import ListViewMixin from '@/mixins/ListViewMixin'

export default {
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    demoImages: [
      'appImage-signup-forms--1',
      'appImage-signup-forms--2',
      'appImage-signup-forms--3'
    ],
    product: signupForms
  }),
  computed: mapState({
    formsList: state => state.apps.formsList
  }),
  methods: {
    getList () {
      this.$store.dispatch('apps/LIST', {
        resource: 'signup_forms/forms'
      })
    }
  }
}
</script>
<style scoped>
  .component-hero {
    background-image: url('../../../assets/appBg-signup-forms--hero.png');
    background-position: center;
    background-size: cover;
  }
</style>